<template>
  <div>
    <div class="login-background">
    <div class="login-centering">
      <CForm class="my-form" v-on:keyup.enter="!validate ? attempLogin() : ''">
        <div class="login-welcome-row">
          <img src="../../public/static/astronaut.jpg" alt="Astronauta" class="login-welcome">
          <h1 class="login-h1">&Oacute;ptimo</h1>
        </div>
        <div class="login-text-field">
          <CInput
            label="Usuario"
            placeholder="Usuario"
            autocomplete="user"
            :value.sync="userEmail">
          </CInput>
          <img src="../../public/static/email.svg" alt="User" class="input-icon">
        </div>
        <div class="login-text-field">
          <CInput
            label="Contraseña"
            placeholder="Contraseña"
            type="password"
            autocomplete="curent-password"
            :value.sync="psswrd">
          </CInput>
          <img src="../../public/static/password.svg" alt="Password" class="input-icon">
        </div>
        <CButton 
          class="my-form_button"
          :disabled="validate"
          :class="validate ? 'disabled' : ''"
          @click="attempLogin()">
          <i class="bi bi-box-arrow-in-right mr-2"></i>
          Inicia Sesi&oacute;n
        </CButton>
        <div class="my-form_actions">
          <div class="my-form_row">
            <span>¿Olvido su contrase&ntilde;a?</span>
            <a href="#" class="text-muted">
              Restablecer contrase&ntilde;a
            </a>
          </div>
        </div>
      </CForm>
    </div>
  </div>

  <CElementCover v-show="loading"/>

      <!-- <CAlert 
        @update:show="(value)=> alertEvent(value)"
        class="w-50 mx-auto mt-5 fixed-top"
        :color="alert.color" :closeButton="typeof(alert.show)!=='number'" :show.sync="alert.show">
        {{alert.message}}   
        <CProgress
          v-if="typeof(alert.show)=='number'"
          :max="5"
          :value="alert.show"
          height="3px"
          :color="alert.color"
          animate
          class="my-3"
        />         
      </CAlert> -->

      <!-- <CModal
      color="dark"
      title="Recuperacion de contraseña"
      :show.sync="showModal"
      :centered="true"
      :closeOnBackdrop="false"
      :backdrop="true">
      <template v-slot:body-wrapper>
        <CRow>
          <CCol col="sm-12">

          </CCol>
        </CRow>
        <CContainer class="text-left mt-4 mb-2">
          <CInput
            label="Usuario registrado"
            placeholder="Usuario"
            autocomplete="user"
            :value.sync="userEmail">
            <template #prepend-content>
              <CIcon name="cil-user"/>
            </template>
          </CInput>
          <p>
            Se enviaran las instruciones para recuperar la contraseña del usuario al correo electronico registrado.
          </p>
        </CContainer>
      </template>
      <template v-slot:footer>
        <CContainer class="text-center">
          <CButton
            color="success"
            square 
            class="mr-2 d-inline-block"
            @click="recoveryPassword()">
            Solicitar
          </CButton>
        </CContainer>
      </template>
    </CModal> -->
  </div>
</template>

<style scoped>
</style>

<script>
  import moment from 'moment'
  import { 
    getKey, 
    dataUsuarioSession,
    grabaAccesoUsuario,
    actualizaSesionUsuario,
    solicitaClaveUsuario
  } from '../api'
  import {
    errorMessage,
    getRoutesModel,
    user_uid
  } from '../general'

  export default {
    name: 'Login2',
    data(){
      return {
        loading: false,
        userEmail: '',
        psswrd: '',
        backgroundImage: '',        
        showModal: false,
        modalMessage: '',
      }
    },
    methods: {
      async attempLogin(){
        try {
          this.loading = true
          
          try {
            const { token } = await getKey(this.userEmail, this.psswrd)
            await grabaAccesoUsuario(this, this.userEmail, true)
            this.$store.commit('setUserValue', ['token', token])
            this.$store.commit('setUserValue', ['isLoggedIn', true])
            this.$store.commit('setUserValue', ['logginDate', moment().format()])

            const { response } = await dataUsuarioSession(this, token)
            const userData = response

            this.$store.commit('setUserValue', ['type', userData.tipo_Usuario[0]])


            console.log(userData.tipo_Usuario)
            console.log(this.$store.state.user.type)

            if (this.$store.state.user.type === 'E') {
              await this.updateSessionStatus(
                async () => {
                  const routesModel = await getRoutesModel()
                  this.$store.commit(
                    'setUserValue', 
                    [
                      'data', 
                      {
                        ...userData,
                        routesAccessModel: routesModel
                      }
                    ]
                  )
                  
                  this.$router.push({path: routesModel[0].children[0].path })

                  this.loading = false
                }
              )
            } else {
              const routesModel = await getRoutesModel()
              this.$store.commit(
                'setUserValue', 
                [
                  'data', 
                  {
                    ...userData,
                    routesAccessModel: routesModel
                  }
                ]
              )
              
              this.$router.push({path: routesModel[0].children[0].path })

              this.loading = false
            }
          } catch (error) {
            await grabaAccesoUsuario(this, this.userEmail, false)
            const message = {...error}.response.data.non_field_errors ? {...error}.response.data.non_field_errors[0] : 'Error al cargar datos'

            this.loading = false

            this.$store.commit(
              'setAlert',
              { 
                color: 'danger',
                message: message,
                show: 5 
              }
            )
          }
        } catch(err) {
          this.setAlert(false)
        } finally {
          this.loading = false
        }
      },
      async updateSessionStatus(continuation) {
        try{
          await actualizaSesionUsuario(
            this,
            user_uid(), 
            'A'
          )
          continuation()
        } catch(error) {
          this.$store.commit('setAlert', {
            color: 'danger',
            message: errorMessage(error.response),
            show: 5
          })
        }
      },
      async recoveryPassword() {
        try {
          this.loading = true

          await solicitaClaveUsuario(this.userEmail)
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error en la recuperacion de contraseña.",
            show: 5
          })
        } finally {
          this.loading = false
          this.showModal = false
        }
      },
      alertEvent(value){
        if (typeof(value) == 'boolean') {    
          this.$store.commit('setAlert',{ show: false })
        } else {
          // console.log(value)
          if (!value) {
            this.$store.commit('setAlert',{ show: false })
          }
        }
      },
      setAlert(value){
        this.$store.commit(
          'setAlert',
          { 
            color: value ? 'success' : 'danger',
            message: value ?'Acción exitosa':'No se pudo iniciar sesión',
            show: 5 
          }
        )
      },
      getImagesList() {
        return require.context('../../public/static/img/background', true, /\.jpg$/)
      },
      setImageBackground(){
        const images = this.getImagesList()
        const randomValue = Math.floor(Math.random() * images.keys().length)
        this.backgroundImage = images(images.keys()[randomValue])
      }
    },
    computed:{
      alert() {
        return this.$store.state.alert
      },
      validate() {
        return (this.psswrd.length==0)||(this.userEmail.length==0)
      }
    },
    mounted() {
      // this.$forceUpdate()
    }
  }
</script>